import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { isLoggedIn, getUsername, clearAuth } from '../auth';
import '../styles/NavBar.css';

export default function NavBar() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const location = useLocation();

  const logged = isLoggedIn();
  const username = getUsername();

  // Close mobile menu on route change
  useEffect(() => {
    setOpen(false);
  }, [location]);

  function logout() {
    clearAuth();
    nav('/login');
  }

  // Helper for active class
  const navClass = ({ isActive }) =>
    `nav-item ${isActive ? 'active' : ''}`;

  return (
    <nav className="navbar print-hide">
      <div className="nav-container">

        {/* Brand */}
        <NavLink to="/" className="brand">
          <span className="brand-icon">🚜</span> Nk Dairy Farm
        </NavLink>

        {/* Burger Button */}
        <button className="burger" onClick={() => setOpen(!open)}>
          {!open ? (
            <svg width="24" height="24" viewBox="0 0 24 24">
              <line x1="3" y1="6" x2="21" y2="6" stroke="#2d3436" strokeWidth="2" />
              <line x1="3" y1="12" x2="21" y2="12" stroke="#2d3436" strokeWidth="2" />
              <line x1="3" y1="18" x2="21" y2="18" stroke="#2d3436" strokeWidth="2" />
            </svg>
          ) : (
            <span style={{ fontSize: 22 }}>✕</span>
          )}
        </button>


        {/* Menu */}
        <div className={`nav-menu ${open ? 'open' : ''}`}>

          {/* Links */}
          <div className="nav-links">
            {logged && (
              <>
                <NavLink to="/" end className={navClass}>
                  Farmers
                </NavLink>

                <NavLink to="/milkrecs" className={navClass}>
                  Milk Records
                </NavLink>

                <NavLink to="/interests" className={navClass}>
                  Interests
                </NavLink>

                <NavLink to="/nagadamount" className={navClass}>
                  Nagad Amount
                </NavLink>

                <NavLink to="/oldamount" className={navClass}>
                  Old Amount
                </NavLink>

                <NavLink to="/farmerledger" className={navClass}>
                  Reports
                </NavLink>
              </>
            )}
          </div>

          {/* Auth Section */}
          <div className="nav-auth">
            {!logged ? (
              <NavLink to="/login" className="login-btn">
                Login
              </NavLink>
            ) : (
              <div className="user-dropdown">
                <div className="user-trigger">
                  <span className="user-avatar">
                    {username?.[0]?.toUpperCase()}
                  </span>
                  <span className="username">{username}</span>
                </div>

                <div className="dropdown-content">
                  <NavLink to="/profile/change-password">
                    Change Password
                  </NavLink>
                  <button onClick={logout} className="logout-btn">
                    Logout
                  </button>
                </div>
              </div>
            )}
          </div>

        </div>
      </div>
    </nav>
  );
}
